import { AmeliproColorsTypes } from './types';

export const AmeliproColors: AmeliproColorsTypes = {

	//base colors
	apPrimary: {
		hexColor: '#00749C'
	},
	apSecondary: {
		hexColor: '#00516D'
	},
	apError: {
		hexColor: '#B33F2E'
	},
	apInformations: {
		hexColor: '#4D547D'
	},
	apSuccess: {
		hexColor: '#007863'
	},
	apWarning: {
		hexColor: '#906C16'
	},
	apBlack: {
		hexColor: '#000000'
	},
	apWhite: {
		hexColor: '#FFFFFF'
	},
	apGrey: {
		hexColor: '#545859'
	},
	apBlue: {
		hexColor: '#0C419A'
	},
	apYellow: {
		hexColor: '#F0B323'
	},
	apGreen: {
		hexColor: '#56C271'
	},
	apRed: {
		hexColor: '#B33F2E'
	},
	apTurquoise: {
		hexColor: '#33BCA5'
	},
	apParme: {
		hexColor: '#C8D1E6'
	},
	// grey darken
	apGreydarken1: {
		hexColor: '#2A2C2C'
	},
	// grey lighten
	apGreylighten1: {
		hexColor: '#CCCDCE'
	},
	apGreylighten2: {
		hexColor: '#DDDEDE'
	},
	apGreylighten3: {
		hexColor: '#EEEEEE'
	},
	apGreylighten4: {
		hexColor: '#F3F4F4'
	},
	apGreylighten5: {
		hexColor: '#FAFAFA'
	},
	// blue darken
	apBluedarken1: {
		hexColor: '#00749C'
	},
	apBluedarken2: {
		hexColor: '#00516D'
	},
	// blue lighten
	apBluelighten1: {
		hexColor: '#99DBF2'
	},
	apBluelighten2: {
		hexColor: '#CCEDF9'
	},
	apBluelighten3: {
		hexColor: '#E6F6FC'
	},
	// yellow darken
	apYellowdarken1: {
		hexColor: '#D8A120'
	},
	apYellowdarken2: {
		hexColor: '#C08F1C'
	},
	apYellowdarken3: {
		hexColor: '#A87D19'
	},
	apYellowdarken4: {
		hexColor: '#906C16'
	},
	// yellow lighten
	apYellowlighten1: {
		hexColor: '#F3C24F'
	},
	apYellowlighten2: {
		hexColor: '#FED66D'
	},
	apYellowlighten3: {
		hexColor: '#F7D990'
	},
	apYellowlighten4: {
		hexColor: '#F9E1A7'
	},
	apYellowlighten5: {
		hexColor: '#FCF0D3'
	},
	// green darken
	apGreendarken1: {
		hexColor: '#459B5A'
	},
	apGreendarken2: {
		hexColor: '#337343'
	},
	// green lighten
	apGreenlighten1: {
		hexColor: '#78CE8D'
	},
	apGreenlighten2: {
		hexColor: '#DDF3F3'
	},
	// red darken
	apReddarken1: {
		hexColor: '#9D3728'
	},
	apReddarken2: {
		hexColor: '#70281C'
	},
	// red lighten
	apRedlighten1: {
		hexColor: '#E67261'
	},
	apRedlighten2: {
		hexColor: '#EC9588'
	},
	apRedlighten3: {
		hexColor: '#F9DCD7'
	},
	// turquoise darken
	apTurquoisedarken1: {
		hexColor: '#007863'
	},
	apTurquoisedarken2: {
		hexColor: '#006654'
	},
	apTurquoisedarken3: {
		hexColor: '#005647'
	},
	// turquoise lighten
	apTurquoiselighten1: {
		hexColor: '#CCEEE8'
	},
	apTurquoiselighten2: {
		hexColor: '#E6F7F4'
	},
	// parme darken
	apParmedarken1: {
		hexColor: '#4D547D'
	}
};
